import * as Yup from 'yup';
import { useFormik, FormikHelpers } from 'formik';

export interface FormPaymentData {
    number: string;
    expiryMonth: string;
    expiryYear: string;
    ccv: string;
    holderName: string;
    isSubscription: boolean;
}

const initialValues: FormPaymentData = {
    number: '',
    expiryMonth: '',
    expiryYear: '',
    ccv: '',
    holderName: '',
    isSubscription: true,
};

const validationSchema = Yup.object({
    number: Yup.string().required('O número do cartão é obrigatório.'),
    expiryMonth: Yup.string().required('O mês de vencimento é obrigatório.').matches(/^(0[1-9]|1[0-2])$/, 'Mês inválido (MM).'),
    expiryYear: Yup.string().required('O ano de vencimento é obrigatório.').matches(/^(20\d{2}|\d{2})$/, 'Ano inválido (AAAA ou AA).'),
    ccv: Yup.string().required('O CVV é obrigatório.').matches(/^[0-9]{3,4}$/, 'CVV inválido (3 ou 4 dígitos).'),
    holderName: Yup.string().required('O nome do titular é obrigatório.')
});

export const useFormPayment = (
    onSubmitCallback: (values: FormPaymentData, formikHelpers: FormikHelpers<FormPaymentData>) => void | Promise<any>
) => {
    const formik = useFormik<FormPaymentData>({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values, formikHelpers) => {
            await onSubmitCallback(values, formikHelpers);
        },
    });

    return formik;
};